import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import '../css/BisharatMain.css';
import AuthService from "../services/AuthService";
import EmailService from '../services/EmailService';

// import logo from "../data/images/logo.png";
import Login from '../pages/Login';
import translate from "../languages/translate";

const required = value => {
  if (!value) {
    return (
      <div className="alertDanger" role="alert">
        <p className="alertDanger">{translate("mandatory")}  
          </p> 
      </div>
    );
  }
};


const verifyname = value => {
  if (value.length < 3 || value.length > 20) {
    return (
      <div className="alertDanger" role="alert">
        <p className="alertDanger">
     {translate("name-not-appropriate")}
      </p>
      </div>
    );
  }
};


const verifysubject = value => {
    if (value.length < 5 ) {
      return (
        <div className="alertDanger" role="alert">
          <p className="alertDanger" >
          {translate("specify")}
        </p>
        </div>
      );
    }
  };
  

  
const verifycontent = value => {
    if (value.length > 500 ) {
      return (
        <div className="alertDanger" role="alert">
          <p className="alertDanger">
        {translate("not-appropriate")}
        </p>
        </div>
      );
    }
  };
  

export default class ContactUs extends Component {
  constructor(props) {
    super(props);
    this.handleSendMail = this.handleSendMail.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onChangeSubject = this.onChangeSubject.bind(this);
    this.onChangeContent = this.onChangeContent.bind(this);
    // this.onChangePassword = this.onChangePassword.bind(this);

    this.state = {
      currentUser: AuthService.getCurrentUser(),
      name: "",
      mailSubject : "",
      mailContent : "",
      successful: false,
      message: ""
    };
  }




  onChangeName(e) {
    this.setState({
        name: e.target.value
    });
  }

  

  onChangeContent(e) {
    this.setState({
        mailContent: e.target.value
    });
  }

  onChangeSubject(e) {
    this.setState({
        mailSubject: e.target.value
    });
  }

  handleSendMail(e) {
    e.preventDefault();

    this.setState({
      message: "",
      successful: false
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      EmailService.contactUs(
        this.state.name,
        this.state.currentUser.email,
        this.state.mailSubject,
        this.state.mailContent,
      ).then(
        response => {
          this.setState({
            message: response.data.message,
            successful: true
          });
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            successful: false,
            message: resMessage
          });
        }
      );
    }
  }

  render() {
    const loggedInUser = AuthService.getCurrentUser();
 
    return (
      <div className='top-level-page-main main-contactus'>
       
             
    
         {!loggedInUser ? <div> 
          <Login></Login>
         </div> : 
           <div className="top-container-contactus">
         <div>
          <Form
            onSubmit={this.handleSendMail}
            ref={c => {
              this.form = c;
            }}
          >
            {!this.state.successful && (
              <div>
                <div className="form-group">
                  <label htmlFor="name">{translate("full-name")} </label>
                  <Input
                    type="text"
                    className="form-control"
                    name="name"
                    value={this.state.name}
                    onChange={this.onChangeName}
                    validations={[required, verifyname]}
                  />
                </div>

             
                <div className="form-group">
                  <label htmlFor="mailSubject"> {translate("msg-subject")} </label>
                  <Input
                    className="form-control"
                    name="mailSubject"
                    value={this.state.mailSubject}
                    onChange={this.onChangeSubject}
                    validations={[required, verifysubject]}
                  />
          
                </div>

                <div className="form-group">
                  <label htmlFor="mailContent"> {translate("msg-content")}</label>
                <textarea className="form-control contentarea"
                rows="8"
                name="mailContent"
                value={this.state.mailContent}
                onChange={this.onChangeContent}
                validations={[required, verifycontent]}
/>

                  {/* <Input 
                    className="form-control"
                    name="mailContent"
                    value={this.state.mailContent}
                    onChange={this.onChangeContent}
                    validations={[required, verifycontent]}
                  /> */}
                </div>

              

                <div className="form-group">
                  <button className="btn btn-primary btn-block">{translate("send")}</button>
                  <a className="btn" href="/"> {translate("back")} </a>
                </div>
              </div>
            )}

            {this.state.message && (
              <div className="form-group">
                <div
                  className={
                    this.state.successful
                      ? "alertSuccess" 
                      : "alertDanger"
                  }
                  role="alert"
                >
                  <div className="contact-us-respo">
                {/* <img className="logo-contact-us" 
                src={logo} 
                alt="Contact Us Page I"/> */}

                        {(this.state.message === "Thanks!") ? 
                        <h2>شكراً</h2> 
                        : <h2>شكراً</h2> }  
                  
                </div>
                <a className="btn" href="/"> رجوع </a>
              
              </div>
              </div>
            )}
            <CheckButton
              style={{ display: "none" }}
              ref={c => {
                this.checkBtn = c;
              }}
            />
          </Form>
          </div> </div>}
     
      
      </div>
   
    );
  }
}